import PdfInvoice from "./PdfInvoice";
import { pdf } from '@react-pdf/renderer';
import { saveAs } from "file-saver";
import { formatNoGroup, formatShortDate } from "./utiil/Formate";
import { currencyFormate, formate } from "./utiil/Formate";
import { getPeriodNameByPeriod } from "./utiil/Dates";


const ProjectDetails = ({ show, onClose, project }) => {

    const handlePDFDownload = async () => {
        const pdfInvoice = await pdf(<PdfInvoice project={project} />).toBlob();
        const file = new Blob([pdfInvoice], { type: 'application/pdf' });
        saveAs(file, project.code + ".pdf")
    }

    const handleCSVDownload = async () => {
        const headers = ['ProjectCode', 'ProjectName', 'SpentDate', 'User', 'Task', 'Hours', 'Amount'].join(";").concat("\n");
        const data = project.data.map(d => {
            return [project.code,
                project.name,
                formatShortDate(new Date(d.period.year, d.period.month, d.spent_date)),
                d.user.name,
                d.task,
                formatNoGroup(d.hours),
                formatNoGroup(d.amount)
            ].join(";")
        }).join("\n");

        const blob = new Blob(["﻿" + headers.concat(data)], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, project.code + ".csv")
    }

    if (!show) return <></>;

    const users = Object.values(project.users).sort((a, b) => b.sum_hours - a.sum_hours);
    const periodName = getPeriodNameByPeriod(project.period);

    return (
        <div className="modal">
            <div className="modal-content">

                <div className="modal-header">
                    <div>
                        <div className="modal-project-code">{project.code}</div>
                        <div className="modal-project-name">{project.client.name} – {project.name}</div>
                    </div>
                    <button className="pdf-csv-close-button" onClick={onClose}>✕</button>
                </div>

                <div className="modal-meta">
                    <div className="modal-meta-item">
                        <span className="modal-meta-label">Period</span>
                        <span className="modal-meta-value">{periodName}</span>
                    </div>
                    <div className="modal-meta-item">
                        <span className="modal-meta-label">Hours</span>
                        <span className="modal-meta-value">{formate(project.sum_hours)}</span>
                    </div>
                    <div className="modal-meta-item">
                        <span className="modal-meta-label">Amount</span>
                        <span className="modal-meta-value">{currencyFormate(project.sum_amount)} kr</span>
                    </div>
                </div>

                <div className="modal-users">
                    {users.map(user => (
                        <div key={user.id} className="modal-user-row">
                            <span className="modal-user-name">{user.name}</span>
                            <span className="modal-user-hours">{formate(user.sum_hours)} t</span>
                        </div>
                    ))}
                </div>

                <div className="buttons-container">
                    <div className="download-container">
                        <button className="pdf-csv-close-button" onClick={handlePDFDownload}>PDF</button>
                        <button className="pdf-csv-close-button" onClick={handleCSVDownload}>CSV</button>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default ProjectDetails;
